import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"; 
import commonNetwork from "../../common/api/commonNetwork";


interface GetLinksParameters {
  parameters: {
    [key: string]: any; // Adjust the type according to your parameter structure
  };
}

interface GetLinksResponse {
  data: any; // Replace with the actual data structure of the response
}

interface GetLinksError {
  message: string; // Error message structure
}


export const getLinks = createAsyncThunk<GetLinksResponse, GetLinksParameters, { rejectValue: GetLinksError }>(
  "/links",
  async ({ parameters }, { rejectWithValue }) => {
    try {
      
      const method = "/get-payment-links";

      const { data, errorMessage, isSuccess } = await commonNetwork.post(method, parameters);

      if (isSuccess) {
        return {data};
      } else {
        return rejectWithValue(data);
      }
    } catch (e:any) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const linkListSlice = createSlice({
  name: "linklist",
  initialState: {
    links: [],
    totalPage: 1,
    currentPage: 1,
    limit: 10,
    totalRecords: 0,
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    selectedCustomer : {},
    isfetchComplete : false
  },
  reducers: {
    clearState: (state) => {
      state.links = [];
      state.totalPage = 1;
      state.currentPage = 1;
      state.limit = 25;
      state.totalRecords = 0;
      state.selectedCustomer = {}; 
      state.isfetchComplete = false;
      return state;
    },
    onSelectOrderLinkListCustomer: (state, action) => {
      state.selectedCustomer = action.payload; 

      return state;
    },
    clearOrderLinkListCustomer: (state, action) => {
      state.selectedCustomer = {}; 
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getLinks.fulfilled, (state, { payload }) => {
      state.links = payload.data;
      // state.currentPage = payload.currentPage || 0 ;
      state.totalPage = payload.data.length;
      // state.limit = payload.limit || 0;
      state.totalRecords = payload.data.length;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      state.isfetchComplete = true;
      return state;
    });
    builder.addCase(getLinks.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
    });
    builder.addCase(getLinks.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState, onSelectOrderLinkListCustomer, clearOrderLinkListCustomer } = linkListSlice.actions;

export const linkListSelector = (state:any) => state.linklist;

export const linkListReducer = linkListSlice.reducer;
